import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateExecutadoPorColumnsDefinition
 */

type Props = {
  lockFuncionarioAprovado: boolean;
  statusChecklistServico: number | null;
  onActionDelete: (idExecutadoPor: number | null, openState: boolean) => void;
};

export const GenerateExecutadoPorColumnsDefinition = ({
  lockFuncionarioAprovado,
  statusChecklistServico,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "empresa",
      filterable: false,
      headerName: "Nome da Empresa",
      flex: 1,
      minWidth: 120,
      sortable: false,
      valueGetter: (_, row) => ({ centroCusto: row.centroCusto, fornecedor: row.fornecedor }),
      renderCell: ({ value }) => (
        <div className="py-2 flex items-center">{value.centroCusto ?? value.fornecedor}</div>
      )
    },
    {
      field: "funcionarios",
      filterable: false,
      headerName: "Nomes dos Funcionários",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="py-2 flex flex-col">
          {(typeof value === 'object' && value instanceof Array) &&
            value.map((x, index) => (
              <div key={index}>{x}</div>
            ))
          }
        </div>
      )
    },
    {
      field: 'delete',
      sortable: false,
      filterable: false,
      headerName: 'Excluir',
      width: 65,
      valueGetter: (_, row) => row['idExecutadoPor'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={statusChecklistServico === 1 || lockFuncionarioAprovado}
              onClick={() => { onActionDelete(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}